module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-Footer-Work-Anywhere-Stretches.ebd9582b.jpg";